module.exports = __webpack_public_path__ + "fonts/3107C8_5_0.b0a16c3.woff";